import './TermsOfService.css';
import mrlogo from './images/M_R-White.png';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
function Footer() {
  return (
    <div class="tos">
        <p>Last updated: October 18th, 2022</p>

        <h1>Music Server Charts Terms Of Service</h1>
        <p>"We", "Us", "Our" in this policy refers to us, the team behind Music Server Charts and not any other services or websites linked in our services.</p>
        <p>"Service", "Services" refers to all services provided by us, including but not limited to the Music Server Charts Website and the Music Server Charts bot application.</p>
        <p>"Agreement" collectively refers to our <Link to="/tos">Terms</Link> and <Link to="/privacy">Privacy Policy</Link>.</p>
        <p>By accessing, browsing or using our services, you agree to allow us to store information we need to provide the services to you as mentioned in this agreement.</p>
        
        <h2>1. Rules Of Conduct</h2>

        <p>The services are provided “As is” and are to be used for the intended purpose(s) only and coincide that you may not use our services
          to break <a href="https://discord.com/terms">Discords Terms and Policies</a>,&nbsp; 
          <a href="https://www.spotify.com/us/legal/end-user-agreement/">Spotify's Terms Of Use</a> and any other applicable third-party rights.<br />
          Attempts to find loopholes in our Terms and/or our services and exploit it with the intention of causing damage to us or
          anyone else may result in termination of your access to our services.
        </p>

        <h2>2. Intellectual Property</h2>
        <p>Any content or material owned by us in our services are prohibited from being used without prior authorization.</p>

        <h2>3. Your Content</h2>
        <p>You grant us a license of your content, which allows us to use, copy, store, distribute, communicate, publish, publicly perform, publicly display, monitor, modify, translate, reformat and sublicense your content in accordance with legal requirements and in connection with our services.<br />
        This license is worldwide, non-exclusive, royalty-free, transferable and perpetual.</p>

        <h2>4. Termination Of Services</h2>
        <p>In case of evidence of users or servers abusing our service, we will take action by saving the users public ID to be able to
          exclude said users or servers. We reserve the right to remove and permanently delete your content from the service with or without notice for any
          reason or no reason.
        </p>

        <h2>5. Limitation Of Liability</h2>
        <p>The services are provided "As is", we're not liable for any laws broken intentionally or otherwise using our services
          and/or any damages that may arise from the use of our service.</p>

        <h2>6. Updates to this Policy</h2>
        <p>We may update this policy from time to time. The updated version will be indicated by an updated Revised date and available on this page.</p>

        <h2>7. Contact</h2>
        <p>If you have any questions about this notice, you may contact us in by any of the following:<br />
        E-Mail: <a href="mailto:msc@marcorennmaus.de">msc@marcorennmaus.de</a><br />
        Discord: <a href="https://discord.gg/WZbXEMF">https://discord.gg/WZbXEMF</a></p>
    </div>
  );
}

export default Footer;
